import React, { useEffect } from "react";
import MyInput from "../shared/form/MyInput";
import MySubmit from "../shared/form/MySubmit";
import { createUser } from "../../api/apiRequests";
import { useState } from "react";
import { useNavigationContext } from "../shared/nav/Navigation";

const initialData = {
  name: "",
  surname: "",
  address: "",
  cp: "",
  location: "",
  city: "",
  country: "",
  birthDay: "",
  birthMonth: "",
  birthYear: "",
  nationality: "",
  passport: "",
  driversLicense: "",
  phone: "",
  emailConfirm: "",
  email: "",
}

const NewUser = () => {

  const { setMenuVisible } = useNavigationContext()
  const [state, setState] = useState({})
  const [finished, setFinished] = useState(false)
  const errors = []

  const {
    name = "",
    surname = "",
    address = "",
    cp = "",
    location = "",
    city = "",
    country = "",
    birthDay = "",
    birthMonth = "",
    birthYear = "",
    nationality = "",
    passport = "",
    driversLicense = "",
    phone = "",
    emailConfirm = "",
    email = "",
  } = state

  const captureErrors = (where, isCorrect) => {
    const indice = errors.indexOf(where);
    const existsIndice = indice >= 0;
    isCorrect ? (existsIndice && errors.splice(indice, 1)) : (!existsIndice && errors.push(where));
  };

  const changeInfo = (event) => setState({
    ...state, [event.target.name]: (event.target.value)
  });

  const onSubmit = (event) => {
    event.preventDefault();
    if (errors.length < 1) {
      createUser({
        ...state,
        password: "fk-pssw-" + state.email,
        passwordConfirmation: "fk-pssw-" + state.email,
        role: "customer"
      })
        .then(() => {
          // alert("Los datos han sido introducidos correctamente \n The data has been entered correctly")
          setFinished(true)
        })
        .catch(() => {
          alert("¡Ups! Ha habido un error. Acuda a nuestro personal para continuar \n Oops! An error has occured. Contact our staff to continue")
        })
    } else {
      alert("Todos los campos son obligatorios \n All fields are required")
    }
  };

  useEffect(() => {
    setMenuVisible(false)
    return () => setMenuVisible(true)
    // eslint-disable-next-line
  }, []);

  if (finished) return (
    <div className="container">
      <div className="row justify-content-center align-items-center vh-100 ff-bobby h3 text-center">
        <div>
          <p>
            Gracias <span style={{ opacity: 0.7 }} className="ml-3">Thank you</span>
            <br/>
            {email}
          </p>
          <br/>
          <p>
            Los datos han sido introducidos correctamente
            <br/>
            <span style={{ opacity: 0.7 }}>
          The data has been entered correctly
            </span>
          </p>
          <div className="d-flex justify-content-center mt-5">
            <button className="btn btn-primary" onClick={() => {
              setFinished(false)
              setState(initialData)
            }}>
              Reiniciar / Restart
            </button>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className="container py-5">
      <form onSubmit={onSubmit} className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12 col-md-6">
              <MyInput title="Nombre / Name" type="text" name="name" value={name}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mr-md-2"/>
            </div>
            <div className="col-12 col-md-6">
              <MyInput title="Apellidos / Surname" type="text" name="surname" value={surname}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="ml-md-2"/>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-8">
              <MyInput title="Dirección / Address" type="text" name="address" value={address}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mr-md-2"/>
            </div>
            <div className="col-6 col-md-4">
              <MyInput title="CP / Postal Code" type="text" name="cp" value={cp}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="ml-md-2"/>
            </div>
            <div className="col-6 col-md-4">
              <MyInput title="Localidad / Locality" type="text" name="location" value={location}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mr-md-2"/>
            </div>
            <div className="col-6 col-md-4">
              <MyInput title="Ciudad / City" type="text" name="city" value={city}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mr-md-2 ml-md-2"/>
            </div>
            <div className="col-6 col-md-4">
              <MyInput title="País / Country" type="text" name="country" value={country}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="ml-md-2"/>
            </div>
          </div>
          <div className="row my-font-sz-08 my-font-wg-500 mb-1">Fecha de nacimiento / Birthdate</div>
          <div className="row">
            <div className="col-4">
              <MyInput title="Día / Day" type="number" name="birthDay" value={birthDay} placeholder={"ex: 03"}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mr-md-2"/>
            </div>
            <div className="col-4">
              <MyInput title="Mes / Month" type="number" name="birthMonth" value={birthMonth} placeholder={"ex: 06"}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mx-md-2"/>
            </div>
            <div className="col-4">
              <MyInput title="Año / Year" type="number" name="birthYear" value={birthYear} placeholder={"ex: 1985"}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="ml-md-2"/>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6">
              <MyInput title="Nacionalidad / Nationality" type="text" name="nationality" value={nationality}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mr-md-2"/>
            </div>
            <div className="col-12 col-sm-6">
              <MyInput title="Nº pasaporte o ID / passport or ID" type="text" name="passport" value={passport}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="ml-md-2"/>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6">
              <MyInput title="Nº licencia de conducir / Driver's license number" type="text" name="driversLicense"
                       value={driversLicense}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mr-md-2"/>
            </div>
            <div className="col-12 col-sm-6">
              <MyInput title="Télefono / Phone" type="number" name="phone" value={phone}
                       onChange={changeInfo} captureErrors={captureErrors} maxChar={20} minChar={9}
                       notEmpty={true}
                       className="ml-md-2"/>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6">
              <MyInput title="Email" type="text" name="email" value={email}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       className="mr-md-2"/>
            </div>
            <div className="col-12 col-sm-6">
              <MyInput title="Confirmación Email / Email confirmation" type="email" name="emailConfirm"
                       value={emailConfirm}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}
                       equal={email} className="ml-md-2"/>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-6 mt-4">
              <MySubmit style={{ height: "48px" }} text={"FINALIZAR / FINISH"} className="bg-success"/>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default NewUser